import {AbstractControl, FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {LIMITES_CARACTERES} from "../../helper/limites-caracteres.const";
import {TipoProspeccao} from "../../enum/tipoPessoaProspeccao.enum";
import moment from "moment";
import {TipoCotacao} from "../../enum/tipo-cotacao.enum";

export class NovaCotacao {
  propostaId: string;
  documentoCedente: string;
  nomeCliente: string;
  nomeCedente: string;
  numeroPrecatorio: string;
  numeroProcesso: string;
  observacao: string;
  destacado: boolean;
  tipoCompra: string;
  honorarios: number;
  dtBase: string;
  dtExpedicao: string;
  esfera: string;
  estado: string;
  municipio: string;
  idPrecatorioCrm: number;
  leadId: number;
  honorariosContratuaisDestacados: string;
  parcelaPreferencialPaga: string;
  dataPgtoParcelaPreferencial: string;
  valorPgtoParcelaPreferencial: number;
  valorOficio: number;
  documentos: Array<DocumentoModel> = [];
  documento: Array<any> = [];
  esteiraId: number;
  existente: boolean = false;
  tipoCotacao: TipoCotacao;
  titulo: string;
  valorProposta: string;
  valorComissao: string;
  dataVencimento: string;
  urlCartaProposta: string;
  exibirContraproposta: boolean;
  propostaFeita = false;

  form: FormGroup;

  constructor(other?: any) {
    if (other) {
      this.propostaId = other.propostaId;
      this.documentoCedente = other.documentoCedente;
      this.nomeCliente = other.nomeCliente;
      this.nomeCedente = other.nomeCedente;
      this.numeroPrecatorio = other.numeroPrecatorio;
      this.numeroProcesso = other.numeroProcesso;
      this.observacao = other.observacao;
      this.destacado = other.destacado;
      this.tipoCompra = other.tipoCompra;
      this.honorarios = other.honorarios;
      this.dtBase = other.dtBase;
      this.dtExpedicao = other.dtExpedicao;
      this.esfera = other.esfera;
      this.estado = other.estado;
      this.municipio = other.municipio;
      this.idPrecatorioCrm = other.idPrecatorioCrm;
      this.leadId = other.leadId;
      this.honorariosContratuaisDestacados = other.honorariosContratuaisDestacados;
      this.parcelaPreferencialPaga = other.parcelaPreferencialPaga;
      this.dataPgtoParcelaPreferencial = other.dataPgtoParcelaPreferencial;
      this.valorPgtoParcelaPreferencial = other.valorPgtoParcelaPreferencial;
      this.valorOficio = other.valorOficio;
      this.urlCartaProposta = other.urlCartaProposta;
      this.documentos = new Array<DocumentoModel>();
      if(other.documentos != null && other.documentos instanceof Array) {
        other.documentos.forEach((value) => { this.documentos.push(new DocumentoModel(value)); });
      }
      this.documento = other.documento;
      this.esteiraId = other.esteiraId;
      this.tipoCotacao = other.tipoCotacao;
      if(other.pesquisa) {
        this.leadId = other.leadId;
        this.documentoCedente = other.documento;
        this.nomeCedente = other.nome;
        this.numeroProcesso = other.processosPrecatorio[0].numeroProcesso;
        this.numeroPrecatorio = other.processosPrecatorio[0].numeroPrecatorio;
        this.estado = other.processosPrecatorio[0].estado;
        this.esfera = other.processosPrecatorio[0].esfera;
        this.valorOficio = other.processosPrecatorio[0].valorOficio;
        this.dtExpedicao = other.processosPrecatorio[0].dataProcesso ? moment(other.processosPrecatorio[0].dataProcesso).format('YYYY-MM-DD') : null;
      }
      if(other.pesquisaNaoEncontrada) {
        this.documentoCedente = other.documento;
        this.numeroProcesso = other.numeroProcesso;
        this.numeroPrecatorio = other.numeroPrecatorio;
      }
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      const documentosEnviados = [];
      this.documentos.forEach((value) => documentosEnviados.push(value.asForm));
      this.form = new FormGroup({
        /* PASSO 2 */
        documentoCedente: new FormControl(this.documentoCedente, this.validarDocumento()),
        nomeCedente: new FormControl(this.nomeCedente),
        numeroPrecatorio: new FormControl(this.numeroPrecatorio),
        numeroProcesso: new FormControl(this.numeroProcesso),
        valorOficio: new FormControl(this.valorOficio),
        dtBase: new FormControl(this.dtBase),
        dtExpedicao: new FormControl(this.dtExpedicao),
        esfera: new FormControl(this.esfera),
        estado: new FormControl(this.estado),
        municipio: new FormControl(this.municipio),
        /* PASSO 3 */
        documentos: new FormArray(documentosEnviados),
        /* PASSO 4 */
        honorariosContratuaisDestacados: new FormControl(this.honorariosContratuaisDestacados),
        honorarios: new FormControl(this.honorarios),
        parcelaPreferencialPaga: new FormControl(this.parcelaPreferencialPaga),
        dataPgtoParcelaPreferencial: new FormControl(this.dataPgtoParcelaPreferencial),
        valorPgtoParcelaPreferencial: new FormControl(this.valorPgtoParcelaPreferencial),


        /* Nao sendo utilizado */
        tipoCotacao: new FormControl(this.tipoCotacao),
        observacao: new FormControl(this.observacao, [Validators.maxLength(LIMITES_CARACTERES.OBSERVACAO)]),
        destacado: new FormControl(this.destacado),
        tipoCompra: new FormControl(this.tipoCompra),

        /* Campos para o CRM - Verficar */
        idPrecatorioCrm: new FormControl(this.idPrecatorioCrm),
        leadId: new FormControl(this.leadId),
        esteiraId: new FormControl(this.esteiraId),
      });
    }
    return this.form;
  }

  get asDocumentosFormArray(): FormArray {
    const x = this.form.get('documentos') as FormArray;
    return this.form.get('documentos') as FormArray;
  }
  validarDocumento() {
    return (control: AbstractControl): Validators => {
      const cpf = control.value;
      if (cpf) {
        let numeros, digitos, soma, i, resutado, digitosIguais;
        digitosIguais = 1;
        if (cpf.length > 11) {
          if(this.isValidCnpj(cpf)) {
            return null;
          } else {
            return {documentoInvalido: true};
          }
        }

        for (i = 0; i < cpf.length - 1; i++) {
          if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
            digitosIguais = 0;
            break;
          }
        }

        if (!digitosIguais) {
          // Verificar o tipo do Usuario
          numeros = cpf.substring(0, 9);
          digitos = cpf.substring(9);
          soma = 0;
          for (i = 10; i > 1; i--) {
            soma += numeros.charAt(10 - i) * i;
          }

          resutado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

          if (resutado !== Number(digitos.charAt(0))) {
            return {documentoInvalido: true};
          }
          numeros = cpf.substring(0, 10);
          soma = 0;

          for (i = 11; i > 1; i--) {
            soma += numeros.charAt(11 - i) * i;
          }
          resutado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

          if (resutado !== Number(digitos.charAt(1))) {
            return {documentoInvalido: true};
          }
          return null;
        } else {
          return {documentoInvalido: true};
        }
      }
      return null;
    };
  }

  isValidCnpj(cnpj: string): boolean {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj.length !== 14) {
      return false;
    }

    if (/^(\d)\1+$/.test(cnpj)) {
      return false;
    }

    let soma = 0;
    let fator = 5;
    for (let i = 0; i < 12; i++) {
      soma += parseInt(cnpj.charAt(i)) * fator;
      fator = fator === 2 ? 9 : fator - 1;
    }

    let restante = soma % 11;
    let digito = restante < 2 ? 0 : 11 - restante;

    if (parseInt(cnpj.charAt(12)) !== digito) {
      return false;
    }

    soma = 0;
    fator = 6;
    for (let i = 0; i < 13; i++) {
      soma += parseInt(cnpj.charAt(i)) * fator;
      fator = fator === 2 ? 9 : fator - 1;
    }

    restante = soma % 11;
    digito = restante < 2 ? 0 : 11 - restante;

    if (parseInt(cnpj.charAt(13)) !== digito) {
      return false;
    }

    return true;
  }
}
export class DocumentoModel {
  extensao: string;
  base64: string;
  tipoDocumento: string;
  nomeS3: string | null;
  documentoId: string | null;

  form: FormGroup;
  constructor(other?: any) {
    if (other) {
      this.extensao = other.extensao;
      this.base64 = other.base64 ?? null;
      this.tipoDocumento = other.tipoDocumento;
      this.nomeS3 = other.nomeS3 ?? null;
      this.documentoId = other.documentoId ?? null;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      const base64Validators = (!this.nomeS3 && !this.documentoId) ? [Validators.required] : [];
      this.form = new FormGroup({
        extensao: new FormControl(this.extensao, [Validators.required]),
        base64: new FormControl(this.base64, base64Validators),
        tipoDocumento: new FormControl(this.tipoDocumento, [Validators.required]),
        nomeS3: new FormControl(this.nomeS3 ?? null),
        documentoId: new FormControl(this.documentoId ?? null),
      });
    }
    return this.form;
  }

}
